module.exports = __webpack_public_path__ + "static/media/sports_21.8fce8fc6.jpg";